import React, { useCallback, useState } from 'react';

import PropTypes from 'prop-types';
import { StylesProvider } from '@mui/styles';
import { ThemeProvider } from '@mui/material';
import { themeCreator } from './base';

export const ThemeContext = React.createContext();

const ThemeProviderWrapper = ({ children }) => {
  const curThemeName = localStorage.getItem('appTheme') || 'NebulaFighterTheme';
  const [themeName, setThemeName] = useState(curThemeName);
  const theme = themeCreator(themeName);

  const updateThemeName = useCallback((themeName) => {
    localStorage.setItem('appTheme', themeName);
    setThemeName(themeName);
  }, [setThemeName]);

  return (
    <StylesProvider injectFirst>
      <ThemeContext.Provider value={updateThemeName}>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </ThemeContext.Provider>
    </StylesProvider>
  );
};

export default ThemeProviderWrapper;
ThemeProviderWrapper.propTypes = {
  children: PropTypes.node,
};